module.exports = __webpack_public_path__ + "img/logoVitae.67d31414.png";